import { Routes, RouterModule } from '@angular/router';
import { ManagementComponent } from './management.component';
import { InviteUserComponent } from './users-management/invite-user/invite-user.component';
import { UserRecordComponent } from './users-management/user-record/user-record.component';
import { IsAuthorized } from '@app/guards/IsAuthorized';

const routes: Routes = [
  {
    path: '',
    component: ManagementComponent,
  },
  {
    path: 'invite-user',
    component: InviteUserComponent,
  },
  {
    path: 'user/:email',
    data: {
      role: 'Admin',
    },
    canActivate: [IsAuthorized],
    component: UserRecordComponent,
  },
];

export const ManagementRoutingRoutes = RouterModule.forChild(routes);
